@use "variables" as *;

.gradeNumber {
  font-size: $fontSize-m;
  font-weight: bold;
  font-variant: tabular-nums;
  margin-right: $spacing-m;
}

.goldmineRatingCard {
  flex-shrink: 0;
}
